import { AxiosInstance } from 'axios';
// cspell:disable
export const TIMEZONE_MAP: Record<string, string> = {
  'America/Matamoros': 'AMMT',
  'Etc/GMT': 'EGMT',
  'Australia/Sydney': 'AUSY',
  'Asia/Kolkata': 'ASKO',
  'Asia/Tokyo': 'ASTO',
  'America/Ojinaga': 'AMOJ',
  'Pacific/Auckland': 'PAAU',
  'Asia/Shanghai': 'ASSH',
  'America/Mazatlan': 'AMMZ',
  'America/Hermosillo': 'AMHE',
  'America/Mexico_City': 'AMMX',
  'America/Tijuana': 'AMTJ',
  'Australia/Melbourne': 'AUME',
  'America/Chihuahua': 'AMCH',
  'Australia/Perth': 'AUPE',
  'Australia/Adelaide': 'AUAD',
  'America/Chicago': 'AMCG',
  'America/Los_Angeles': 'AMLA',
  'Africa/Johannesburg': 'AFJO',
  'Australia/Brisbane': 'AUBR',
  'America/Cancun': 'AMCN',
  'Asia/Bangkok': 'ASBK',
  'America/Detroit': 'AMDT',
  'Australia/Hobart': 'AUHO',
  'America/Ciudad_Juarez': 'AMCJ',
};

const REGION_DEFAULT: Record<string, keyof typeof TIMEZONE_MAP> = {
  America: 'America/Chicago',
  Asia: 'Asia/Shanghai',
  Australia: 'Australia/Melbourne',
  Africa: 'Africa/Johannesburg',
  Pacific: 'Pacific/Auckland',
  Etc: 'Etc/GMT',
};

export const getTimezoneValue = (iana: string): string => {
  if (iana in TIMEZONE_MAP) {
    return TIMEZONE_MAP[iana];
  }

  const region = iana.split('/')[0];
  const fallbackKey = REGION_DEFAULT[region] ?? 'Etc/GMT';

  return TIMEZONE_MAP[fallbackKey];
};

export const setTimezone = async (iana: string, axios: AxiosInstance): Promise<void> => {
  const tzCode = getTimezoneValue(iana);

  try {
    await axios.post(
      `/api/v1/sisense/timezone/sync/${tzCode}`,
    );
  } catch (error) {
    console.error('Failed to sync timezone:', error);
  }
};
